//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'empleado',
        value: 'hr_employee_full_name',
    },
    {
        text: 'tipo',
        value: 'hr_contract_type_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            },
        },
    },
    {
        text: 'horas',
        value: 'weekly_hours',
        align: 'center',
    },
    {
        text: 'comienzo',
        value: 'init_date',
        align: 'right',
        format: 'date',
    },
    {
        text: 'termino',
        value: 'end_date',
        align: 'right',
        format: 'date',
    },
    {
        text: 'activo',
        value: 'active',
        align: 'center',
        format: 'boolean',
    },
]
